/***
 * Created on 2025/7/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalComponent from "../common/ModalComonent/ModalComponent";
import {useTranslation} from "react-i18next";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import {useParams} from "react-router-dom";
import {useAlertContext} from "../../context/AlertContext";
import {invalidateAccessGrant} from "../../service/accessGrantSync";

function AccountListSuspendModal({isSuspend, onClose, isOpen, row_data, doRefresh}) {
    const { t } = useTranslation();
    const {oid} = useParams();
    const {OrganizationAPI} = useOrganizationApi();
    const alert = useAlertContext();
    const queryClient = useQueryClient();
    const getTitle = !isSuspend ? `${t('@Suspend {{display_name}}@', {display_name: row_data?.display_name})}` : `${t('@Unsuspend {{display_name}}@', {display_name: row_data?.display_name})}`;
    const getOkText = !isSuspend ? `${t('@Suspend@')}` : `${t('@Unsuspend@')}`;
    const getContentText = !isSuspend ?
        <>
            <p>{t('@This account will no longer be able to access the organization devices and cloud services.If this user currently occupies a license seat, the license will remain in use.@')}</p>
            <p>{t('@You can remove the suspension or delete the account at any time.@')}</p>
        </>
        :
        <>{t('@This member will regain access to organization devices and services. If the account still holds a license seat, it will resume using the service immediately.@')}</>

    const updateMutation = useMutation({
        mutationFn: async (data) => await OrganizationAPI.put(`organization/${oid}/qid/${row_data?.email || row_data?.qid}`, null, data),
        onSuccess: (data, variables, context) => {
            console.log('Status updated successfully:', data, variables, context);
            const message = variables.status === 'suspend' ? t('@Suspended {{display_name}}@', {display_name: row_data?.display_name}) : t('@Unsuspended {{display_name}}@', {display_name: row_data?.display_name});
            invalidateAccessGrant(queryClient, oid);
            doRefresh(prev => prev + 1);
            alert(true, 'success', 'ok', message, 10 * 1000);
            onClose();
        },
        onError: (error) => {
            console.error('Error updating status:', error);
            // Surface the backend error (e.g. 1060022 owner cannot suspend self) instead of
            // silently swallowing it. Dialog stays open (onClose only runs on success).
            const code = error?.response?.data?.code;
            alert(true, 'error', code, t('@Failed to update status. Please try again.@'), 10 * 1000);
        }
    })

    const onUpdateStatus = async () => {
        const data = {
            status: isSuspend ? 'active' : 'suspend',
        };
        await updateMutation.mutateAsync(data);
    }


    return (
        <ModalComponent title={getTitle} okText={getOkText} onClose={onClose} isOpen={isOpen} onSubmit={onUpdateStatus}>
            <div className="dialog-content">
                {getContentText}
            </div>
        </ModalComponent>
    );
}

export default AccountListSuspendModal;